__webpack_require__.p = "https://static.lingoapp.com/web/assets/";